import { useEffect, useRef } from "react";

// Taken from https://stackoverflow.com/a/57706747
const usePrevious = <T>(value: T): T | undefined => {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export default usePrevious;
